export const stage: string = import.meta.env.VITE_STAGE || 'production';
